<template>
    <ul class="breadcrumb">
        <li v-for="crumb in crumbs">
            <router-link :to="buildLink(crumb)">{{localize(crumb)}}</router-link>
        </li>
    </ul>
</template>
<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';

    @Component
    export default class RouterBreadcrumb extends Vue {
        get crumbs() {
            const topCrumb = this.$route.name;
            const meta = this.$route.meta;
            if (meta && meta.crumbs) {
                return [...meta.crumbs, topCrumb];
            } else {
                return [topCrumb];
            }
        }

        buildLink(crumb) {
            if (typeof(crumb) === 'object') {
                return crumb;
            } else {
                return {
                    name: crumb,
                };
            }
        }

        localize(crumb) {
            const name = (typeof(crumb) === 'object') ? crumb.name : crumb;
            return this.$t('route.' + name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/RouterBreadcrumb.vue